export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_assigned_scope_only',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const CUSTOM_ROLE_PERMISSION_GROUPS = [
  {
    key: 'CONVERSATIONS',
    permissions: AVAILABLE_CUSTOM_ROLE_PERMISSIONS.filter(permission =>
      permission.startsWith('conversation_')
    ),
  },
  {
    key: 'REPORTING',
    permissions: ['report_manage'],
  },
  {
    key: 'ADMINISTRATION',
    permissions: ['contact_manage', 'knowledge_base_manage'],
  },
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_assigned_scope_only',
];

export const CONVERSATION_ASSIGNED_SCOPE_ONLY =
  'conversation_assigned_scope_only';

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  // Teletel tabs — visible to everyone; the server scopes the rows per agent.
  active_24h: {
    count: 'active24hCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unread: {
    count: 'unreadCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
